import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { LOADING, IDLES } from 'state/constants';

import { fetchAiStagingOrder } from 'state/actions';

export const useAiServices = () => {
  const {
    selectedPicture,
    listing_pictures,
    orderParams,
    canProceed,
    noMoreSteps,
    listing_id,
    result,
    currentStep,
    hideButtons,
    selectedService,
    is_AI_promotion_applied,
    nextAiStagingOrderIsFree,
    showDisclaimer,
    creatingOrder,
    selectedRoomType,
    selectedRoomStyle,
  } = useSelector((state: any) => {
    return state.aiServices;
  });

  return {
    selectedPicture,
    listing_pictures,
    orderParams,
    canProceed,
    noMoreSteps,
    listing_id,
    result,
    currentStep,
    hideButtons,
    selectedService,
    is_AI_promotion_applied,
    nextAiStagingOrderIsFree,
    showDisclaimer,
    creatingOrder,
    selectedRoomType,
    selectedRoomStyle,
  };
};

export const useAiStagingOrder = (listing_id: number, token: string) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(LOADING.NONE);
  const { orders, onGoingIterations, onGoingOrders, iterationOrOrderOngoing } = useSelector(
    (state: any) => {
      return state.aiStagingOrder;
    },
  );
  const loadAiStagingOrder = async () => {
    const isIdle = IDLES.includes(loading);
    if (token && isIdle) {
      setLoading(LOADING.STARTED);
      await dispatch(fetchAiStagingOrder(token, listing_id));
      setLoading(LOADING.FINISHED);
    }
  };
  useEffect(() => {
    loadAiStagingOrder();
  }, [token]);

  return {
    orders,
    onGoingIterations,
    onGoingOrders,
    iterationOrOrderOngoing,
    loading,
  };
};
